import { gsap } from 'gsap';
import { withPlugins, eventBus, inview } from '@spon/plugins';

function ScrollText({ node, plugins: { inview } }) {
	function observeElements(elements) {
		inview.settings = {
			rootMargin: '0px',
			threshold: 0.1,
		};

		inview.observe(elements, {
			enter: entry => {
				entry.target.classList.add(
					'opacity-100'
					// 'transition-opacity',
					// 'duration-300'
				);
			},
			exit: entry => {
				entry.target.classList.remove(
					'opacity-100'
					// 'transition-opacity',
					// 'duration-300'
				);
			},
		});
	}

	observeElements(node.querySelectorAll('[data-reveal]'));

	// window.addEventListener('htmx:afterSettle', event => {
	// 	const { target } = event;

	// 	observeElements(target.querySelectorAll('[data-reveal]'));
	// 	window.removeEventListener('htmx:afterSettle', event);
	// });

	return () => {
		if (inview && typeof inview.disconnect === 'function') {
			inview.disconnect();
		}
	};
}

export default withPlugins(inview)(ScrollText);
